jQuery(document).ready(function($) {
	
	var button = $('.sidebar__menu-button');
	var menu = $('.sidebar__menu');
	
	button.on('click', function() {
		if ( button.is('.close') ) {
			button.removeClass('close');
			menu.removeClass('open');
		} else {
			button.addClass('close');
			menu.addClass('open');
		}
	} );
	
} );